module.exports = __webpack_public_path__ + "img/payment-success.c5a7a802.png";